var _circle, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.499,
    cy: 12.5,
    r: 9.583,
    stroke: "#FF7D0E",
    strokeWidth: 2.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "swrx9yi91a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.719 7.917c0-.346.28-.625.625-.625h.312c.345 0 .625.28.625.625v4.53l2.246 1.195c.305.162.42.54.259.845l-.104.195a.625.625 0 0 1-.838.263l-2.732-1.404a.621.621 0 0 1-.231-.204.623.623 0 0 1-.162-.42v-5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.281 12.447h-1.25v.752l.663.352.587-1.104zm2.246 1.195-.587 1.103.587-1.103zm.259.845-1.104-.587 1.104.587zm-.104.195-1.104-.587 1.104.587zm-.838.263.572-1.112-.572 1.112zm-2.732-1.404.572-1.112-.572 1.112zm-.231-.204 1.034-.702-.05-.073-.059-.066-.925.84zm.463-7.295c-1.036 0-1.875.839-1.875 1.875h2.5c0 .345-.28.624-.625.624v-2.5zm.312 0h-.312v2.5h.312v-2.5zm1.875 1.875c0-1.036-.84-1.875-1.875-1.875v2.5a.625.625 0 0 1-.625-.625h2.5zm0 4.53v-4.53h-2.5v4.53h2.5zm1.583.091-2.246-1.194-1.174 2.207 2.246 1.194 1.174-2.207zm.775 2.536a1.875 1.875 0 0 0-.775-2.536l-1.174 2.207a.625.625 0 0 1-.258-.845l2.207 1.174zm-.104.195.104-.195-2.207-1.174-.104.195 2.207 1.174zm-2.512.788a1.875 1.875 0 0 0 2.512-.788l-2.207-1.174a.625.625 0 0 1 .838-.262l-1.143 2.224zm-2.732-1.404 2.732 1.404 1.143-2.224-2.732-1.404-1.143 2.224zm-.694-.615c.17.253.406.467.694.615l1.143-2.224c.093.048.173.12.231.206l-2.068 1.403zm-.378-1.122c0 .485.185.93.487 1.261l1.85-1.68c.1.11.163.258.163.42h-2.5zm0-5v5h2.5v-5h-2.5z",
    fill: "#FF7D0E",
    mask: "url(#swrx9yi91a)"
  })));
};
export default __webpack_public_path__ + "static/media/working-hours.d18f9433.svg";
export { SvgComponent as ReactComponent };